import { useCallback, useSyncExternalStore } from 'react'

import type { CharterSummary } from '@ankor-io/common/types/charter'

// Simple module-level store (no browser storage) to persist charter during SPA lifetime
let currentCharter: CharterSummary | null = null
const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

const getSnapshot = () => currentCharter

const setStoreCharter = (value: CharterSummary | null) => {
  currentCharter = value
  listeners.forEach((listener) => listener())
}

export const useCharter = () => {
  const charter = useSyncExternalStore(subscribe, getSnapshot)

  const setCharter = useCallback((value: CharterSummary | null) => {
    setStoreCharter(value)
  }, [])

  return { charter, setCharter }
}
